import React from 'react';
import { Icons } from '@beeline/design-tokens/js/iconfont';
import { Icon } from '../../../Icon';
export var CheckboxIcon = function (_a) {
    var _b = _a.type, type = _b === void 0 ? 'checkbox' : _b;
    return (React.createElement(Icon, { className: 'lk-ui_checkbox-icon', size: 'large', iconName: type === 'checkbox' ? Icons.Check : Icons.Remove }));
};
